document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('benefitsDrawer');
  const overlay = document.getElementById('benefitsDrawerOverlay');
  const closeBtn = document.getElementById('benefitsDrawerClose');
  const titleEl = document.getElementById('benefitsDrawerTitle');
  const descEl = document.getElementById('benefitsDrawerDescription');
  const items = document.querySelectorAll('.benefits');

  function openDrawer(title, description) {
    titleEl.textContent = title; // el título normalmente no necesita HTML, lo dejamos así
    descEl.innerHTML = description; // <-- cambio aquí
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('benefits-drawer-is-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Espera 300ms a que termine la animación del drawer antes de restaurar la posición del carrusel
    setTimeout(function () {
      document.body.classList.remove('benefits-drawer-is-open');
    }, 300);
  }

  items.forEach(function (item) {
    item.addEventListener('click', function () {
      const title = item.dataset.title || '';
      const description = item.dataset.description || '';
      openDrawer(title, description);
    });
  });

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
});